import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Box, Grid, useTheme } from "@mui/material";
import { Button, IconButton } from "@mui/material";
import SingleImageViewer from "@/ui/SingleImageViewer";
import { ShowDialogFn } from "@/@types/ui/DialogContext";
import { FieldAny } from "@/@types/models/model";
import api from "@/lib/api";
import ImageControl from "@/controls/ImageControl";

type MultipleImagesControlProps = {
  images: any;
  showDialog: ShowDialogFn;
};
const MultipleImagesControl: FC<MultipleImagesControlProps> = (props) => {
  const { images, showDialog } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 3,
      }}
    >
      {/* @ts-ignore */}
      {images.map((image, i) => (
        <ImageControl
          key={"image-control" + image.uuid}
          showDialog={showDialog}
          image={image}
        />
      ))}
    </Box>
  );
};

export default MultipleImagesControl;
